import { Component, OnInit } from '@angular/core';
import { BookingService } from '../service/booking.service';
import { Booking } from '../booking';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { HttpService } from '../service/http.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { STUDENTLANGUAGES } from '../student-languages-list';
import { Vademecum } from '../vademecum';
import { Router } from '@angular/router';
import { BrugesVndBooking } from '../bruges-vnd-booking';
import { BookingBrugesService } from '../service/booking-bruges.service';

@Component({
  selector: 'app-edit-booking-detail',
  templateUrl: './edit-booking-detail.component.html',
  styleUrls: ['./edit-booking-detail.component.css']
})
export class EditBookingDetailComponent implements OnInit {

  booking!: BrugesVndBooking;
  dashboardUrl!: string;
  duration!: number;
  bookingForm!: FormGroup;
  personalForm!: FormGroup;
  studentLanguages = STUDENTLANGUAGES;
  yearRange: string = "2010:" + moment().add(2, "years").year();

  vademecum!: Vademecum;

  constructor(
    public bookingService: BookingService,
    private formBuilder: FormBuilder,
    private httpService: HttpService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private bookingBrugesService: BookingBrugesService,
    private router: Router
  ) { }

  ngOnInit() {
    this.booking = this.bookingService.bookingToBrugesVndBooking(this.bookingService.booking);

    this.dashboardUrl = "https://languesvivantes-bruges.com/" + this.bookingBrugesService.getPathByStudentLanguage(this.booking.student.language) + "/dashboard/" + this.booking.uuid;
    this.duration = this.booking.endDate.diff(this.booking.startDate, "weeks");
    console.log(this.duration);
    this.bookingForm = this.formBuilder.group({
      firstName: [this.booking.student.firstName, Validators.required],
      lastName: [this.booking.student.firstName, Validators.required],
      startDate: [this.booking.startDate.toDate()],
      endDate: [this.booking.endDate.toDate(), Validators.required],
      studentLanguage: [this.booking.student.language, Validators.required]
    });

    this.httpService.hasVademecum(this.booking.id!)
      .subscribe(res => {
        this.bookingService.hasVademecum = res;
        if (res == true) {
          this.httpService.getVademecumByBookingId(this.booking.id!)
            .subscribe(vademecum => {
              this.vademecum = vademecum;
              this.personalForm = this.formBuilder.group({
                studentMobile: this.vademecum.studentMobile,
                firstParentMobile: this.vademecum.firstParentMobile,
                secondParentMobile: this.vademecum.secondParentMobile,
                firstParentFirstName: this.vademecum.firstParentFirstName,
                firstParentLastName: this.vademecum.firstParentLastName,
                secondParentFirstName: this.vademecum.secondParentFirstName,
                secondParentLastName: this.vademecum.secondParentLastName
              });
            });
        }
      });
  }

  update() {
    this.booking.student.firstName = this.bookingForm.value.firstName;
    this.booking.student.lastName = this.bookingForm.value.lastName;
    let bookingToSend = new Booking(
      moment(this.bookingForm.value.startDate).utc(true),
      moment(this.bookingForm.value.endDate).utc(true),
      true,
      this.booking.school,
      null,
      this.booking.destination,
      this.booking.languageCourse,
      this.booking.commentToSchool,
      this.booking.internalCommentList,
      this.booking.targetLanguageLevel,
      this.booking.accommodation,
      this.booking.travels,
      this.booking.student,
      this.booking.sentToSchool,
      this.booking.schoolConfirmed,
      this.booking.preConfirmationSent,
      this.booking.insuranceSent,
      this.booking.salesAgent,
      this.booking.quotationList,
      this.booking.transferType,
      this.booking.enableAccommodationDates,
      this.booking.courseComment,
      this.booking.activitiesComment,
      this.booking.excursionDate,
      this.booking.promoCode,
      this.booking.highSchoolMeetingDate,
      this.booking.highSchoolTestScore,
      this.booking.flightRequested,
      this.booking.cancellationInsuranceRequested,
      this.booking.travelInsuranceRequested,
      this.booking.depositReceived,
      this.booking.completePaymentReceived,
      this.booking.accommodationSent,
      this.booking.travelInformationSent,
      this.booking.flightBookedDate,
      this.booking.visaInformationSent,
      this.booking.finalConfirmationSent,
      this.booking.bookingConfirmed,
      this.booking.travelRequestCode,
      this.booking.emergencyTransferPhoneNumber,
      this.booking.travelInsuranceSupplier,
      this.booking.cancellationInsuranceSupplier,
      this.booking.emergencyTransferContact,
      this.booking.versionId,
      this.booking.reminderDate,
      this.booking.withPartena,
      this.booking.uuid,
      this.booking.id
    );
    if (this.bookingService.hasVademecum) {
      this.vademecum.studentMobile = this.personalForm.value.studentMobile.trim();
      this.vademecum.firstParentMobile = this.personalForm.value.firstParentMobile.trim();
      this.vademecum.secondParentMobile = this.personalForm.value.secondParentMobile.trim();
      this.vademecum.firstParentFirstName = this.personalForm.value.firstParentFirstName.trim();
      this.vademecum.firstParentLastName = this.personalForm.value.firstParentLastName.trim();
      this.vademecum.secondParentFirstName = this.personalForm.value.secondParentFirstName.trim();
      this.vademecum.secondParentLastName = this.personalForm.value.secondParentLastName.trim();
      this.vademecum.booking = bookingToSend;
      this.updateBookingValue(this.vademecum.booking, bookingToSend);
      this.httpService.updateVademecum(this.vademecum)
      .subscribe(() =>{
        this.addSuccess("Success", "Booking and personal info updated");
        this.updateBookingValue(this.booking, bookingToSend);
      }, error => {
        this.addError("Error", "Failed to update");
      });
    }
    else {
      this.httpService.putBooking(bookingToSend)
      .subscribe(() => {
        this.addSuccess("Success", "Booking updated");
        this.updateBookingValue(this.booking, bookingToSend);
        this.updateUrl();
      }, error => {
        this.addError("Error", "Failed to update");
      }
      );
    }
  }

  delete(){
    this.confirmationService.confirm({
      message: "Are you sure that you want to delete this record?",
      accept: () => {
        this.httpService.deleteBooking(this.booking.id!)
        .subscribe(() => {
          this.router.navigate(["/management/bookings-bruges"]);
        });
      },
      reject: () => {
        return;
      },
      acceptLabel: "Yes, delete it",
      rejectLabel: "No, not sure"
    });
  }


  addSuccess(summary: string, detail: string) {
    this.messageService.add({ severity: 'success', summary: summary, detail: detail });
  }

  addError(summary: string, detail: string) {
    this.messageService.add({ severity: 'error', summary: summary, detail: detail });
  }

  updateUrl() {
    this.dashboardUrl = "https://languesvivantes-bruges.com/" + this.bookingBrugesService.getPathByStudentLanguage(this.booking.student.language) + "/dashboard/" + this.booking.uuid;
  }

  updateBookingValue(oldBooking: Booking, newBooking: Booking){
    oldBooking.student.firstName = newBooking.student.firstName;
    oldBooking.student.lastName = newBooking.student.lastName;
    oldBooking.startDate = newBooking.startDate;
    oldBooking.endDate = newBooking.endDate;
    oldBooking.student.language = newBooking.student.language;
    return oldBooking;
  }

}
